import React from 'react';

import ScrollToTheBottomButton from './ScrollToTheBottomButton/ScrollToTheBottomButton';
import MessagesList from './MessagesList/MessagesList';

import withStoreMessages from './withStoreMessages';

import './css/Messages.css';
import './css/Messages.mobile.css';

@withStoreMessages
class Messages extends React.Component {

  state = {
    scrollToBottom: false,
    unreadMessages: 0
  }
  messagesRef = React.createRef();

  componentDidMount () {
    this.props.loadMessages();
    this.messagesRef.current.addEventListener('scroll', this.onMessagesContainerScroll);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.messages.length !== this.props.messages.length) {
      if (!document.hidden && !this.state.scrollToBottom) {
        this.scrollMessagesToTheBottom();
      } else {
        if (this.messagesRef.current.scrollHeight > this.messagesRef.current.clientHeight) {
          this.setState(prevState => {
            return { scrollToBottom: true, unreadMessages: prevState.unreadMessages + 1 }
          });
        }
      }
    }
  }

  scrollMessagesToTheBottom = () => {
    this.messagesRef.current.scrollTop = this.messagesRef.current.scrollHeight;
  }

  readAllTheWayToTheBottom = () => {
    this.scrollMessagesToTheBottom();
    this.setState({ unreadMessages: 0 });
  }

  onMessagesContainerScroll = () => {
    if ((this.messagesRef.current.scrollHeight - this.messagesRef.current.clientHeight) - this.messagesRef.current.scrollTop > 200) {
      this.setState({ scrollToBottom: true });
    } else {
      this.setState({ scrollToBottom: false, unreadMessages: 0 });
    }
  }
  
  onMessagesChange = (unread) => {
    if (!document.hidden && !this.state.scrollToBottom) {
      this.scrollMessagesToTheBottom();
    } else {
      if (this.messagesRef.current.scrollHeight > this.messagesRef.current.clientHeight) {
        this.setState(prevState => {
          return { scrollToBottom: true, unreadMessages: unread === 0 ? 0 : prevState.unreadMessages + 1 }
        });
      }
    }
  }
  
  render () {
    const { messages, inputAreaHeight } = this.props;
    const { unreadMessages, scrollToBottom } = this.state;
    return (
      <div
        id="private-chat-conversation-messages"
        ref={this.messagesRef}
        style={{ height: `calc(100% - ${inputAreaHeight}px)` }}>
        <MessagesList
          messages={messages}
          onMessagesChange={this.onMessagesChange}
          scrollMessagesToTheBottom={this.scrollMessagesToTheBottom}/>
        {scrollToBottom && (
          <ScrollToTheBottomButton
            readAllTheWayToTheBottom={this.readAllTheWayToTheBottom}
            unreadMessages={unreadMessages}
            inputAreaHeight={inputAreaHeight}
          />
        )}
      </div>
    );
  }
}

export default Messages;
